(ns ycweb.app.website.cart.pages.details-billing
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cart.pages.details-address :as cart.pages.details-address]
   [ycweb.app.website.cart.parts.common :as cart.common]
   [ycweb.components.common :as cmn]))

(rum/defc billing-address-form < rum/reactive cmn/cursors [app-atom process-atom cart-summary-atom]
  "Billing address selection form - matches step-06.html"
  (cart.pages.details-address/address-selection-form app-atom process-atom cart-summary-atom "Which billing address would you like to use?" :billing))

(defmethod cart.common/checkout-step :details/billing
  [app-atom process-atom cart-summary-atom]
  (billing-address-form app-atom process-atom cart-summary-atom))